/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * HotelIcon
 */
export default class HotelIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M17 1a1 1 0 011 1 2 2 0 002 2 1 1 0 01.987 1.159c.003.014.005.028.006.043l.007.116V21h1a1 1 0 01.117 1.993L22 23H2a1 1 0 01-.117-1.993L2 21h1V5.318c0-.054.004-.107.013-.159A1 1 0 014 4a2 2 0 002-1.999 1 1 0 011-1h10zm-.874 2H7.874A4.007 4.007 0 015 5.875L5 21h4v-5a1 1 0 01-.117-1.993L9 14h6a1 1 0 01.117 1.993L15 16v5h4V5.874a4.007 4.007 0 01-2.874-2.873zM13 16h-2v5h2v-5zm3-6a1 1 0 01.117 1.993L16 12H8a1 1 0 01-.117-1.993L8 10h8zm0-4a1 1 0 01.117 1.993L16 8H8a1 1 0 01-.117-1.993L8 6h8z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

